module.exports = __webpack_public_path__ + "static/media/banner_desktop.e2bbf2a9.png";